export default __webpack_public_path__ + "static/media/b643ceb5-6a4e-4101-a3dc-91c5327c588a.90d27cb8.jpeg";